(function(){
        var state = {isInit: false};
        var bootstrapGrid = {
            0 : 'body-xs',
            576 : 'body-sm',
            768 : 'body-ml',
            992 : 'body-lg',
            1200 : 'body-xl'
        };

        window.pageState = state;

        var onResize = function(){
            var w = $(window). width();
            state.width = w;
            state.height = $(window).height();
            var gridId = 0;
            $.each(bootstrapGrid, function(gridWidth, gridClass){
                if(w >= gridWidth){
                    gridId = gridWidth;
                }
            });

            if( (state.bootstrapGrid != gridId) || ( state.bootstrapGrid == undefined ) ){
                $('body').removeClass(bootstrapGrid[state.bootstrapGrid]);
                $('body').addClass(bootstrapGrid[gridId]);
                state.bootstrapGrid = parseInt(gridId);
                changeFloatingTopHeight();
            }
            if(state.isInit){
                $(window).trigger('media.pageStateChange', state)
            }else{
                $(window).trigger('media.pageStateInit', state)
            }
            state.isInit = true;
        }

        $(window).on('resize', onResize)
        $(document).on('ready', onResize);

        function changeFloatingTopHeight(){
            state.previousFloatingTopHeight = state.floatingTopHeight;
            if( state.bootstrapGrid < 768){
                var menu = $('.menu_mobile__wrapper #menu');
                if(!menu.length){
                    menu = $('#menu');
                }
                state.floatingTopHeight = menu.height();
            }else{
                state.floatingTopHeight = $('.top-fixed').height();
            }
        }

})();
